import React from "react";
import Navbar from "./Navbar";
import { Motion, motion } from "framer-motion";
import { Image, Sparkles, ShieldCheck, Mail } from "lucide-react";
import Social from "./Social";

function About() {
  return (
    <>
      <Navbar />
      <div className="max-w-4xl mx-auto p-6 text-center">
    
        <motion.h1
          className="text-4xl font-bold text-blue-600"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          About Our Platform
        </motion.h1>

  
        <motion.p
          className="mt-4 text-gray-700"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Welcome to our AI-powered image converter! Our goal is to provide a
          fast, easy, and efficient way to convert images between different
          formats, including JPG, PNG, and WEBP.
        </motion.p>


        <motion.img
          src="/img/about.jpg"
          alt="Image Conversion"
          className="mt-6 w-full max-w-lg mx-auto rounded-lg shadow-lg"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
        />

     
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
     
          <motion.div
            className="p-6 bg-blue-100 rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
          >
            <Image className="mx-auto text-blue-600" size={40} />
            <h2 className="mt-4 text-2xl font-semibold text-blue-500">
              How It Works
            </h2>
            <p className="mt-2 text-gray-600">
              Simply upload your image, choose the format, and let AI do the rest!
            </p>
          </motion.div>

     
          <motion.div
            className="p-6 bg-blue-100 rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
          >
            <Sparkles className="mx-auto text-blue-600" size={40} />
            <h2 className="mt-4 text-2xl font-semibold text-blue-500">
              Why Choose Us?
            </h2>
            <ul className="mt-2 text-gray-600 list-disc list-inside">
              <li>Fast & Free Image Conversions</li>
              <li>AI-Enhanced Quality</li>
              <li>Supports Multiple Formats</li>
            </ul>
          </motion.div>

     
          <motion.div
            className="p-6 bg-blue-100 rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
          >
            <ShieldCheck className="mx-auto text-blue-600" size={40} />
            <h2 className="mt-4 text-2xl font-semibold text-blue-500">
              Secure & Private
            </h2>
            <p className="mt-2 text-gray-600">
              Your files are processed safely and deleted automatically.
            </p>
          </motion.div>

       
          <motion.div
            className="p-6 bg-blue-100 rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
          >
            <Mail className="mx-auto text-blue-600" size={40} />
            <h2 className="mt-4 text-2xl font-semibold text-blue-500">
              Contact Us
            </h2>
            <p className="mt-2 text-gray-600">
              Need help? Email us at{" "}
              <a
                href="mailto:support@example.com"
                className="text-blue-500 underline"
              >
                codestart19@gmail.com
              </a>
            </p>
          </motion.div>
        </div>
      </div>

			<Social />
    </>
  );
}

export default About;
